module.exports = __webpack_public_path__ + "static/media/group-13.0e6dc370.png";